import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const getSessionHeaders = () => ({
  ...JSON.parse(window.localStorage.getItem('Headers') || '{}'),
  token: JSON.parse(window.localStorage.getItem('userToken') || 'null'),
  userID: JSON.parse(window.localStorage.getItem('userID') || 'null')
})

export const getUserType = createAsyncThunk('usertype/getUserType', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetUserTypeList')
  return response.data
})

export const getData = createAsyncThunk('usertype/getData', async (params) => {
  const headers = getSessionHeaders()
  const response = await axios.post('https://api.zasway.com:8443/Users/GetTableSummary', params, { headers })

  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const addUser = createAsyncThunk('usertype/Create', async (User) => {

  const response = await axios.post('https://api.zasway.com:8443/Users/CreateNewUser', User, { mode: 'cors' })

  return response
})

export const getUser = createAsyncThunk('usertype/getUser', async (params) => {
  const headers = getSessionHeaders()
  const response = await axios.post('https://api.zasway.com:8443/Users/GetTableSummary', params, { headers })

  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const getStaffRole = createAsyncThunk('usertype/getStaffRole', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetStaffRoleTypeList')
  return response.data
})

export const getUserList = createAsyncThunk('usertype/getUserList', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Users/GetUserList', params, { mode: 'cors' })

  return response.data
})

export const getUserListForClientPortal = createAsyncThunk('usertype/getUserListForClientPortal', async (params) => {
 
  const response = await axios.post('https://api.zasway.com:8443/Users/GetUserListForClientPortal', params, { mode: 'cors' })

  return response.data
})
export const resetUserEditData = createAsyncThunk('usertype/resetUserEditData', async () => {
  return {
    data: []
  }
})

export const UserTypeSlice = createSlice({
  name: 'usertype',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    userEditData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(getData.fulfilled, (state, action) => {

        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
      })

      .addCase(getUser.fulfilled, (state, action) => {

        state.data = action.payload.data
        state.params = action.payload.params
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
      })

      .addCase(resetUserEditData.fulfilled, (state, action) => {
        state.userEditData = action.payload.data
      })
  }
})

export default UserTypeSlice.reducer
